import React from 'react';
import './PlatinumSignaturePage.css';

const PlatinumSignaturePage = () => {
  return (
    <div className="platinum-signature-main">
      <section className="platinum-signature-hero">
        <div className="platinum-signature-hero-content">
          <h1>Platinum Signature Film</h1>
        </div>
      </section>

      <section className="platinum-signature-main-content">
        <h2>Premium Metallic Technology for Elite Heat Control & Aesthetic Appeal</h2>
        <p>The Platinum Signature Series by Derma Protec represents the pinnacle of metallic window film innovation—combining high-end sputtered metal technology with exceptional optical clarity, corrosion resistance, and installation performance.</p>
        <p>Unlike conventional metallic films, which often suffer from slow drying, high reflectivity, or poor durability, our Platinum Signature Films are engineered with a proprietary sputtering process using advanced metals such as Nickel, delivering:</p>
        <ul>
          <li>Neutral visual appearance</li>
          <li>Low internal and external reflectivity</li>
          <li>Superior corrosion resistance & weather durability</li>
          <li>Ultra-fast drying upon installation</li>
        </ul>
        <hr />
        <div style={{textAlign: 'center', margin: '32px 0'}}>
          <img 
            src="https://i.postimg.cc/TYBp687B/platinum-sign-pic-2.png" 
            alt="Platinum Signature Film Application" 
            className="platinum-content-image"
            style={{maxWidth: '90%', borderRadius: '18px', boxShadow: '0 4px 24px rgba(53,159,149,0.13)'}}
          />
        </div>
        <h3>🔬 What Makes It Unique?</h3>
        <p>Using a specialized technique, we create a porous metallic structure that significantly enhances moisture permeability—a critical factor that dramatically speeds up the drying process during installation.</p>
        <p>The film displays a subtle shift in color tones when viewed from different angles, a feature giving its spectral color play. This dynamic appearance is not just aesthetic—it's functional. The film is engineered to selectively block infrared radiation at targeted wavelengths, significantly reducing heat buildup inside the vehicle. At the same time, it allows visible light to pass through with minimal obstruction, resulting in a high-performance film that delivers excellent heat rejection without compromising clarity or natural light.</p>
        <p>To put this into perspective:</p>
        <p>Our Platinum Signature Film with 30% VLT achieves a moisture permeability of 18.4 g/m²/day, which is over 20 times faster than traditional nickel-based films (typically 0.81 g/m²/day).</p>
        <p>This rapid drying capability means faster installations, fewer post-installation issues, and reduced risk of haze or blemishes—making it a preferred choice among professionals for both automotive and architectural applications.</p>
        <hr />
        <h3>🌡️ Performance Meets Aesthetics</h3>
        <ul>
          <li>High Heat Rejection – Reflects a significant portion of solar energy, helping keep interiors cool and comfortable.</li>
          <li>UV Protection – Blocks 99% of harmful UV rays to protect skin, upholstery, and furnishings.</li>
          <li>Natural Tint Look – Offers a stylish, understated finish with a low-glare, non-mirrored effect.</li>
          <li>Excellent Durability – Resists fading, oxidation, and degradation from humidity or sunlight.</li>
        </ul>
        <hr />
        <h3>Why Choose Platinum Signature?</h3>
        <ul>
          <li>✅ Professional-grade installation performance</li>
          <li>✅ Elegant, neutral aesthetics without the "mirrored" effect</li>
          <li>✅ Quick-drying properties = faster turnaround</li>
          <li>✅ Long-lasting protection in harsh climates</li>
          <li>✅ Perfect for luxury automotive, modern homes, and commercial facades</li>
            </ul>
        <div style={{textAlign: 'center', margin: '32px 0'}}>
          <img 
            src="https://i.postimg.cc/KY2j1PyN/platinum-sign-box-derma-1.png" 
            alt="Platinum Signature Film Box" 
            className="platinum-content-image"
            style={{maxWidth: '90%', borderRadius: '18px', boxShadow: '0 4px 24px rgba(53,159,149,0.13)', marginBottom: '24px'}}
          />
        </div>
        <div className="specs-table-wrapper">
          <table className="specs-table">
            <thead>
              <tr>
                <th>Model</th>
                <th>VLT</th>
                <th>IRR</th>
                <th>UVR</th>
                <th>O.D</th>
                <th>TSER</th>
              </tr>
            </thead>
            <tbody>
              <tr><td>DPPS-05</td><td>5%</td><td>100%</td><td>100%</td><td>0.43</td><td>88%</td></tr>
              <tr><td>DPPS-10</td><td>10%</td><td>100%</td><td>100%</td><td>0.4</td><td>85%</td></tr>
              <tr><td>DPPS-20</td><td>15%</td><td>100%</td><td>100%</td><td>0.55</td><td>81%</td></tr>
              <tr><td>DPPS-30</td><td>28%</td><td>100%</td><td>100%</td><td>0.77</td><td>77%</td></tr>
              <tr><td>DPPS-40</td><td>40%</td><td>100%</td><td>100%</td><td>0.96</td><td>72%</td></tr>
              <tr><td>DPPS-50</td><td>50%</td><td>100%</td><td>100%</td><td>1.18</td><td>70%</td></tr>
            </tbody>
          </table>
        </div>
      </section>

        <div className="cta-section">
          <h2>Experience Premium Protection</h2>
          <p>
            Elevate your vehicle's protection and style with our Platinum Signature Film. 
            Contact us today to learn more about how our premium solution can benefit your vehicle.
          </p>
          <div className="cta-buttons">
          <a href="/find-dealer" className="cta-button primary">Find a Dealer Centre</a>
          <a href="/contact" className="cta-button secondary">Contact Us</a>
        </div>
      </div>
    </div>
  );
};

export default PlatinumSignaturePage; 